(function(){
  const DEBUG = window.location.search.includes('consent_debug=true');
  const SETTINGS = window.KIANUSH_CONSENT_SETTINGS || {};
  
  function log(...args) {
    if (DEBUG) console.log('[KIANUSH Embeds]', ...args);
  }

  // Process all consent-gated embeds on the page
  function processEmbeds() {
    log('Processing embeds...');
    
    // Find all embed placeholders
    const embeds = document.querySelectorAll('[data-consent-embed]:not([data-loaded])');
    
    embeds.forEach(element => {
      const type = element.dataset.consentEmbed;
      
      // Mark as loaded to prevent duplicate processing
      element.dataset.loaded = 'true';
      
      // Hide any placeholder content
      const placeholder = element.querySelector('.embed-placeholder');
      if (placeholder) {
        placeholder.style.display = 'none';
      }
      
      // Create and insert the appropriate iframe
      if (type === 'youtube') {
        const videoId = element.dataset.videoId;
        if (!videoId) {
          log('YouTube embed missing video ID');
          return;
        }
        
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}`;
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.frameBorder = '0';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';
        iframe.title = element.dataset.title || 'YouTube Video';
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        
        // Add wrapper for aspect ratio if not exists
        let wrapper = element.querySelector('.embed-wrapper');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'embed-wrapper';
          wrapper.style.position = 'relative';
          wrapper.style.width = '100%';
          wrapper.style.paddingBottom = '56.25%'; // 16:9 aspect ratio
          element.appendChild(wrapper);
        }
        
        wrapper.appendChild(iframe);
        log('YouTube embed loaded:', videoId);
        
      } else if (type === 'twitch') {
        const channel = element.dataset.channel;
        if (!channel) {
          log('Twitch embed missing channel');
          return;
        }
        
        const parent = window.location.hostname;
        const muted = element.dataset.muted !== 'false';
        
        const iframe = document.createElement('iframe');
        iframe.src = `https://player.twitch.tv/?channel=${channel}&parent=${parent}&muted=${muted}`;
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.frameBorder = '0';
        iframe.allowFullscreen = true;
        iframe.scrolling = 'no';
        iframe.loading = 'lazy';
        iframe.title = element.dataset.title || 'Twitch Stream';
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        
        // Add wrapper for aspect ratio if not exists
        let wrapper = element.querySelector('.embed-wrapper');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'embed-wrapper';
          wrapper.style.position = 'relative';
          wrapper.style.width = '100%';
          wrapper.style.paddingBottom = '56.25%'; // 16:9 aspect ratio
          element.appendChild(wrapper);
        }
        
        wrapper.appendChild(iframe);
        log('Twitch embed loaded:', channel);
        
      } else {
        log('Unknown embed type:', type);
      }
    });
    
    if (embeds.length > 0) {
      log(`Processed ${embeds.length} embed(s)`);
    }
  }

  // Create placeholder for a single element
  function createPlaceholderForElement(element) {
      const type = element.dataset.consentEmbed;
      const thumbnailUrl = element.dataset.thumbnail;
      
      // Mark as having placeholder
      element.dataset.placeholderCreated = 'true';
      
      // Skip if already has placeholder
      if (element.querySelector('.embed-placeholder')) {
        return;
      }
      
      // Create placeholder
      const placeholder = document.createElement('div');
      placeholder.className = 'embed-placeholder';
      
      // Base styles
      let placeholderStyles = `
        position: relative;
        width: 100%;
        padding-bottom: 56.25%;
        border: 1px solid rgba(234, 88, 12, 0.2);
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.3s ease;
      `;
      
      // Add background based on thumbnail availability
      if (thumbnailUrl) {
        placeholderStyles += `
          background-image: url('${thumbnailUrl}');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        `;
      } else {
        placeholderStyles += `
          background: linear-gradient(135deg, rgba(17, 17, 17, 0.98) 0%, rgba(26, 26, 26, 0.98) 100%);
        `;
      }
      
      placeholder.style.cssText = placeholderStyles;
      
      // Add dark overlay for thumbnails to ensure text readability
      if (thumbnailUrl) {
        const overlay = document.createElement('div');
        overlay.style.cssText = `
          position: absolute;
          inset: 0;
          background: linear-gradient(to bottom, 
            rgba(0, 0, 0, 0.3) 0%, 
            rgba(0, 0, 0, 0.7) 50%, 
            rgba(0, 0, 0, 0.9) 100%);
          transition: opacity 0.3s ease;
        `;
        placeholder.appendChild(overlay);
      }
      
      // Add hover effect
      placeholder.addEventListener('mouseenter', () => {
        placeholder.style.borderColor = 'rgba(234, 88, 12, 0.5)';
        placeholder.style.transform = 'scale(1.02)';
        const overlay = placeholder.querySelector('div');
        if (overlay && thumbnailUrl) {
          overlay.style.opacity = '0.8';
        }
      });
      
      placeholder.addEventListener('mouseleave', () => {
        placeholder.style.borderColor = 'rgba(234, 88, 12, 0.2)';
        placeholder.style.transform = 'scale(1)';
        const overlay = placeholder.querySelector('div');
        if (overlay && thumbnailUrl) {
          overlay.style.opacity = '1';
        }
      });
      
      // Check if this is inside a recent video card (smaller container)
      const isInRecentCard = element.closest('.recent-video-card') !== null;
      
      const content = document.createElement('div');
      content.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        color: rgba(237, 237, 237, 0.9);
        font-family: 'Poppins', sans-serif;
        pointer-events: none;
        z-index: 2;
        width: 90%;
        max-width: ${isInRecentCard ? '280px' : '400px'};
      `;
      
      // Add icon and text based on type with play button overlay
      if (type === 'youtube') {
        // Adjust sizes for recent video cards
        const playSize = isInRecentCard ? '50' : (thumbnailUrl ? '100' : '80');
        const bgSize = isInRecentCard ? '35px' : (thumbnailUrl ? '60px' : '40px');
        const bgOpacity = thumbnailUrl ? '0.8' : '0.2';
        const titleSize = isInRecentCard ? '14px' : '18px';
        const subtitleSize = isInRecentCard ? '11px' : '13px';
        const iconMargin = isInRecentCard ? '8px' : '16px';
        const contentPadding = isInRecentCard ? '20px 15px' : '30px 25px';
        
        content.innerHTML = `
          <div style="
            background: radial-gradient(ellipse at center, 
              rgba(0, 0, 0, 0.4) 0%, 
              rgba(0, 0, 0, 0.25) 40%, 
              rgba(0, 0, 0, 0.1) 70%, 
              transparent 100%);
            backdrop-filter: blur(2px);
            -webkit-backdrop-filter: blur(2px);
            padding: ${contentPadding};
          ">
            <div style="position: relative; display: inline-block;">
              <svg width="${playSize}" height="${playSize}" viewBox="0 0 24 24" fill="#ea580c" style="margin: 0 auto ${iconMargin}; filter: drop-shadow(0 2px 8px rgba(0,0,0,0.5));">
                <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
              </svg>
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: ${bgSize}; height: ${bgSize}; background: rgba(234, 88, 12, ${bgOpacity}); border-radius: 50%; backdrop-filter: blur(4px);"></div>
            </div>
            <p style="margin: 0; font-size: ${titleSize}; font-weight: 600; text-shadow: 0 1px 3px rgba(0,0,0,0.8); line-height: 1.2;">YouTube-Video laden</p>
            <p style="margin: 6px 0 0; font-size: ${subtitleSize}; opacity: 0.9; text-shadow: 0 1px 2px rgba(0,0,0,0.8); line-height: 1.3; padding: 0 10px;">Ein Klick lädt das Video und akzeptiert YouTube-Cookies</p>
          </div>
        `;
      } else if (type === 'twitch') {
        // Adjust sizes for recent video cards
        const playSize = isInRecentCard ? '50' : (thumbnailUrl ? '100' : '80');
        const bgSize = isInRecentCard ? '35px' : (thumbnailUrl ? '60px' : '40px');
        const bgOpacity = thumbnailUrl ? '0.8' : '0.2';
        const titleSize = isInRecentCard ? '14px' : '18px';
        const subtitleSize = isInRecentCard ? '11px' : '13px';
        const iconMargin = isInRecentCard ? '8px' : '16px';
        const contentPadding = isInRecentCard ? '20px 15px' : '30px 25px';
        
        content.innerHTML = `
          <div style="
            background: radial-gradient(ellipse at center, 
              rgba(0, 0, 0, 0.4) 0%, 
              rgba(0, 0, 0, 0.25) 40%, 
              rgba(0, 0, 0, 0.1) 70%, 
              transparent 100%);
            backdrop-filter: blur(2px);
            -webkit-backdrop-filter: blur(2px);
            padding: ${contentPadding};
          ">
            <div style="position: relative; display: inline-block;">
              <svg width="${playSize}" height="${playSize}" viewBox="0 0 24 24" fill="#9146ff" style="margin: 0 auto ${iconMargin}; filter: drop-shadow(0 2px 8px rgba(0,0,0,0.5));">
                <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>
              </svg>
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: ${bgSize}; height: ${bgSize}; background: rgba(145, 70, 255, ${bgOpacity}); border-radius: 50%; backdrop-filter: blur(4px);"></div>
            </div>
            <p style="margin: 0; font-size: ${titleSize}; font-weight: 600; text-shadow: 0 1px 3px rgba(0,0,0,0.8); line-height: 1.2;">Twitch-Stream laden</p>
            <p style="margin: 6px 0 0; font-size: ${subtitleSize}; opacity: 0.9; text-shadow: 0 1px 2px rgba(0,0,0,0.8); line-height: 1.3; padding: 0 10px;">Ein Klick lädt den Stream und akzeptiert Twitch-Cookies</p>
          </div>
        `;
      }
      
      // Add click handler for click-to-load
      placeholder.addEventListener('click', function() {
        log(`User clicked ${type} placeholder - loading embed with implicit consent`);
        
        // Store per-service consent (respect theme settings for session persistence)
        const serviceConsent = `${type}_consent`;
        const persistSession = type === 'youtube' ? 
          SETTINGS.auto_load_youtube_consent : 
          SETTINGS.auto_load_twitch_consent;
        
        if (persistSession !== false) { // Default true if not set
          localStorage.setItem(serviceConsent, 'true');
          log(`Stored ${serviceConsent} = true`);
        } else {
          sessionStorage.setItem(serviceConsent, 'true');
          log(`Stored ${serviceConsent} in session only`);
        }
        
        // Load this specific embed
        loadSingleEmbed(element);
        
        // Load all other embeds of the same type
        const allEmbeds = document.querySelectorAll(`[data-consent-embed="${type}"]:not([data-loaded])`);
        allEmbeds.forEach(embed => {
          if (embed !== element) {
            log(`Auto-loading other ${type} embed after consent`);
            loadSingleEmbed(embed);
          }
        });
      });
      
      placeholder.appendChild(content);
      element.appendChild(placeholder);
      
      log(`Created interactive placeholder for ${type} embed`);
  }
  
  // Create placeholders for all embeds (legacy function, kept for compatibility)
  function createPlaceholders() {
    const embeds = document.querySelectorAll('[data-consent-embed]:not([data-placeholder-created])');
    embeds.forEach(element => {
      createPlaceholderForElement(element);
    });
  }
  
  // Load a single embed on user click
  function loadSingleEmbed(element) {
    const type = element.dataset.consentEmbed;
    
    // Hide placeholder
    const placeholder = element.querySelector('.embed-placeholder');
    if (placeholder) {
      placeholder.style.opacity = '0';
      setTimeout(() => placeholder.remove(), 300);
    }
    
    // Mark as loaded
    element.dataset.loaded = 'true';
    
    // Create and insert the appropriate iframe
    if (type === 'youtube') {
      const videoId = element.dataset.videoId;
      if (!videoId) {
        log('YouTube embed missing video ID');
        return;
      }
      
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}`; // Privacy-enhanced mode
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.frameBorder = '0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';
      iframe.title = element.dataset.title || 'YouTube Video';
      iframe.style.position = 'absolute';
      iframe.style.top = '0';
      iframe.style.left = '0';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      
      // Add wrapper for aspect ratio if not exists
      let wrapper = element.querySelector('.embed-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'embed-wrapper';
        wrapper.style.position = 'relative';
        wrapper.style.width = '100%';
        wrapper.style.paddingBottom = '56.25%'; // 16:9 aspect ratio
        element.appendChild(wrapper);
      }
      
      wrapper.appendChild(iframe);
      log('YouTube embed loaded with privacy-enhanced mode:', videoId);
      
    } else if (type === 'twitch') {
      const channel = element.dataset.channel;
      if (!channel) {
        log('Twitch embed missing channel');
        return;
      }
      
      const parent = window.location.hostname;
      const muted = element.dataset.muted !== 'false';
      
      const iframe = document.createElement('iframe');
      iframe.src = `https://player.twitch.tv/?channel=${channel}&parent=${parent}&muted=${muted}&autoplay=false`;
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.frameBorder = '0';
      iframe.allowFullscreen = true;
      iframe.scrolling = 'no';
      iframe.loading = 'lazy';
      iframe.title = element.dataset.title || 'Twitch Stream';
      iframe.style.position = 'absolute';
      iframe.style.top = '0';
      iframe.style.left = '0';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      
      // Add wrapper for aspect ratio if not exists
      let wrapper = element.querySelector('.embed-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'embed-wrapper';
        wrapper.style.position = 'relative';
        wrapper.style.width = '100%';
        wrapper.style.paddingBottom = '56.25%'; // 16:9 aspect ratio
        element.appendChild(wrapper);
      }
      
      wrapper.appendChild(iframe);
      log('Twitch embed loaded:', channel);
    }
  }

  // Handle consent updates
  let embedsLoaded = false;
  
  const handleConsent = (event) => {
    const consent = event.detail || {};
    log('Embeds handling consent update:', consent);
    
    // YouTube and Twitch require marketing consent
    if (consent.marketing && !embedsLoaded) {
      processEmbeds();
      embedsLoaded = true;
    }
  };

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    log('Embeds script initializing...');
    
    // Check for existing consent BEFORE creating placeholders
    let hasMarketingConsent = false;
    let youtubeConsent = false;
    let twitchConsent = false;
    
    try {
      const stored = localStorage.getItem('consent.v1');
      youtubeConsent = localStorage.getItem('youtube_consent') === 'true' || 
                       sessionStorage.getItem('youtube_consent') === 'true';
      twitchConsent = localStorage.getItem('twitch_consent') === 'true' || 
                      sessionStorage.getItem('twitch_consent') === 'true';
      
      if (stored) {
        const data = JSON.parse(stored);
        log('Found existing consent for embeds:', data);
        hasMarketingConsent = data.marketing === true;
      }
    } catch (e) {
      log('Error checking existing consent:', e);
    }
    
    // If marketing consent exists, load all embeds directly (no placeholders)
    if (hasMarketingConsent) {
      log('Marketing consent exists, loading all embeds directly');
      processEmbeds();
      embedsLoaded = true;
    } else {
      // No general marketing consent, check per-service and create placeholders
      const embeds = document.querySelectorAll('[data-consent-embed]:not([data-loaded])');
      
      embeds.forEach(element => {
        const type = element.dataset.consentEmbed;
        
        // Check if this specific service has consent
        if ((type === 'youtube' && youtubeConsent) || 
            (type === 'twitch' && twitchConsent)) {
          log(`Loading ${type} embed based on per-service consent`);
          loadSingleEmbed(element);
        } else {
          // No consent for this service, create placeholder
          if (!element.querySelector('.embed-placeholder') && !element.dataset.placeholderCreated) {
            createPlaceholderForElement(element);
          }
        }
      });
    }
    
    log('Embeds script ready');
  });

  // Listen for consent updates
  window.addEventListener('consent:update', handleConsent);

  // Also listen for dynamic content (e.g., sections loaded via AJAX)
  const observer = new MutationObserver(() => {
    // Use the same logic as initialization
    if (embedsLoaded) {
      // If we have marketing consent, process new embeds directly
      processEmbeds();
    } else {
      // Check per-service consent for new elements
      const youtubeConsent = localStorage.getItem('youtube_consent') === 'true' || 
                             sessionStorage.getItem('youtube_consent') === 'true';
      const twitchConsent = localStorage.getItem('twitch_consent') === 'true' || 
                           sessionStorage.getItem('twitch_consent') === 'true';
      
      const embeds = document.querySelectorAll('[data-consent-embed]:not([data-loaded]):not([data-placeholder-created])');
      embeds.forEach(element => {
        const type = element.dataset.consentEmbed;
        
        if ((type === 'youtube' && youtubeConsent) || 
            (type === 'twitch' && twitchConsent)) {
          // Load directly without placeholder
          loadSingleEmbed(element);
        } else {
          // Only create placeholder if no consent
          createPlaceholderForElement(element);
        }
      });
    }
  });

  // Start observing when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();